import { Injectable, Inject } from '@angular/core';
import { Router, CanActivate, CanActivateChild,ActivatedRouteSnapshot,RouterStateSnapshot } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import { CookieService } from 'ngx-cookie';
import { AuthenticationService } from './../_services/index';
import { APP_CONFIG, IAppConfig } from './../app.config';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router,
    private _cookieService: CookieService,
    private auth: AuthenticationService,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const host = window.location.host;
    console.log(host);

    if( host === 'localhost:6609') {

      console.log(state.url);

      const authResult = localStorage.getItem('token');
      if(authResult){
        const decoded = jwt_decode(authResult);
        const exp = decoded.exp;
        const ctime = Date.now() / 1000;
        const ctimefix = parseInt(ctime.toFixed(0), 10);
        if (exp < ctimefix) {
          localStorage.removeItem('token');
          localStorage.removeItem('currentUser');
          this._cookieService.remove('token', {
            domain: this.config.domainname
          });
          localStorage.setItem('return-url',state.url );
          this.router.navigate(['/login']);
          return false;
        } else {
          return true;
        }

      }
      else{
        localStorage.setItem('return-url',state.url );
          this.router.navigate(['/login']);
          return false;
      }
        
    }
    else 
    {

      if (this._cookieService.get('token')) {
        const token = this._cookieService.get('token');
        if (localStorage.getItem('currentUser')) {
          const authResult = localStorage.getItem('token');
          if (token === authResult) {
            const decoded = jwt_decode(authResult);
            const exp = decoded.exp;
            const ctime = Date.now() / 1000;
            const ctimefix = parseInt(ctime.toFixed(0), 10);
            if (exp < ctimefix) {
              localStorage.removeItem('token');
              localStorage.removeItem('currentUser');
              this._cookieService.remove('token', {
                domain: this.config.domainname
              });
              localStorage.setItem('return-url',state.url );
              this.router.navigate(['/login']);
              return false;
            } else {
              return true;
            }
          } 
          else 
          {
            this.auth.verifyToken(token).subscribe((response) => {
              localStorage.removeItem('token');
              localStorage.removeItem('currentUser');
              if (response.success === 1) {
                localStorage.setItem('currentUser', JSON.stringify(response.data));
                localStorage.setItem('token', response.data.token);
                this.router.navigate(['/profile/personal-information']);
              }
            },
            error => {
              this._cookieService.remove('token', {
                domain: this.config.domainname
              });
              localStorage.setItem('return-url',state.url );
              this.router.navigate(['/']);

            });
          }
        } else {
          this.auth.verifyToken(token).subscribe((response) => {
            localStorage.removeItem('token');
            localStorage.removeItem('currentUser');
            if (response.success === 1) {
              localStorage.setItem('currentUser', JSON.stringify(response.data));
              localStorage.setItem('token', response.data.token);
              this.router.navigate(['/profile/personal-information']);
            }
          },
          error => {
            this._cookieService.remove('token', {
              domain: this.config.domainname
            });
            localStorage.setItem('return-url',state.url );
            this.router.navigate(['/']);

          });
        }
  
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
        localStorage.setItem('return-url',state.url );
        this.router.navigate(['/']);
      }

    }

  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    console.log(state.url);

    const host = window.location.host;

    if( host === 'localhost:6609') {

        const authResult = localStorage.getItem('token');
        if(authResult){
          const decoded = jwt_decode(authResult);
          const exp = decoded.exp;
          const ctime = Date.now() / 1000;
          const ctimefix = parseInt(ctime.toFixed(0), 10);
          if (exp < ctimefix) {
            localStorage.removeItem('token');
            localStorage.removeItem('currentUser');
            this._cookieService.remove('token', {
              domain: this.config.domainname
            });
            localStorage.setItem('return-url',state.url );
            this.router.navigate(['/login']);
            return false;
          } else {
            return true;
          }
        }
        else
        {
          localStorage.setItem('return-url',state.url );
          this.router.navigate(['/login']);
          return false;
        }
    }
    else {

      if (this._cookieService.get('token')) {
        const token = this._cookieService.get('token');
        if (localStorage.getItem('currentUser')) {
          const authResult = localStorage.getItem('token');
          if (token === authResult) {
            const decoded = jwt_decode(authResult);
            const exp = decoded.exp;
            const ctime = Date.now() / 1000;
            const ctimefix = parseInt(ctime.toFixed(0), 10);
            if (exp < ctimefix) {
              localStorage.removeItem('token');
              localStorage.removeItem('currentUser');
              this._cookieService.remove('token', {
                domain: this.config.domainname
              });
              localStorage.setItem('return-url',state.url );
              this.router.navigate(['/login']);
              return false;
            } else {
              return true;
            }
          } else {
            this.auth.verifyToken(token).subscribe((response) => {
              localStorage.removeItem('token');
              localStorage.removeItem('currentUser');
              if (response.success === 1) {
                localStorage.setItem('currentUser', JSON.stringify(response.data));
                localStorage.setItem('token', response.data.token);
                this.router.navigate(['/profile/personal-information']);
              }
            },
              error => {
                this._cookieService.remove('token', {
                  domain: this.config.domainname
                });
                localStorage.setItem('return-url',state.url );
                this.router.navigate(['/']);
  
              });
          }
        } else {
          this.auth.verifyToken(token).subscribe((response) => {
            localStorage.removeItem('token');
            localStorage.removeItem('currentUser');
            if (response.success === 1) {
              localStorage.setItem('currentUser', JSON.stringify(response.data));
              localStorage.setItem('token', response.data.token);
              this.router.navigate(['/profile/personal-information']);
            }
          },
            error => {
              this._cookieService.remove('token', {
                domain: this.config.domainname
              });
              localStorage.setItem('return-url',state.url );
              this.router.navigate(['/']);
  
            });
        }
  
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
        localStorage.setItem('return-url',state.url );
        this.router.navigate(['/']);
      }

    }
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_guards/auth.guard.ts